var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 100,
    viewBox: "0 0 187 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_227_1086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 141.639C0.0655582 160.645 14.4567 174.97 33.4635 174.97C47.3957 175.101 58.9656 167.6 64.4552 155.024L66.1395 151.131H56.6912L55.9478 152.727C51.9235 161.367 43.5688 166.506 33.5953 166.506C23.9503 166.572 10.565 159.813 8.9685 144.678H66.731C66.731 144.678 67.1244 142.404 66.9932 140.129C66.1842 121.188 51.858 108.197 33.5953 108.197C14.4567 108.241 0.0655582 122.567 0 141.639ZM33.5946 116.662H33.7257C44.9679 116.202 55.7504 125.301 57.8281 136.28H9.23001C11.3733 124.907 21.3467 116.662 33.5946 116.662Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.27 108.701H115.786C115.786 108.701 98.2454 149.994 94.1556 159.639C90.0874 149.994 72.6122 108.701 72.6122 108.701H63.8418L91.4872 173.572H96.8457L124.557 108.701H120.27Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.942 141.092C119.942 159.836 134.662 174.555 153.471 174.555C172.281 174.555 187 159.836 187 141.092C187 122.348 172.281 107.628 153.471 107.628C134.662 107.628 119.942 122.348 119.942 141.092ZM127.904 141.092C127.904 126.438 138.883 115.328 153.471 115.328C168.06 115.328 179.039 126.373 179.039 141.092C179.039 155.811 168.06 166.791 153.471 166.791C138.883 166.878 127.904 155.768 127.904 141.092Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.563 25.8955L117.187 16.7973H102.336L94.0245 0L85.7354 16.7973H70.9502L80.5736 25.8955H107.563Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.248 76.9868H5.81836V84.3574H181.248V76.9868Z",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.0582 34.5347C84.9927 48.7947 74.5595 59.5772 62.0279 60.0368H6.21191V67.867L62.0279 67.8015C78.8252 67.2763 92.954 52.8852 93.0851 34.5354H85.0582",
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.647 60.0368C114.65 59.5116 104.283 48.7291 104.152 34.5347H96.1904C96.256 52.8845 110.45 67.2763 128.647 67.8008L180.592 67.8663V60.0361H128.647",
    fill: "#040404"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_227_1086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 187,
    height: 174.973,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvo);
export default __webpack_public_path__ + "static/media/EVO.1509f826cb612506fd52ac91ccd93857.svg";
export { ForwardRef as ReactComponent };